(() => {
	function getCurrencySign() {
		const currencySignHolder = document.querySelector("[data-currency-sign]");
		return currencySignHolder.dataset.currencySign;
	}
	function formatPrice(price) {
		return price / 100;
	}
	function escapeHtml(text) {
		const map = {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			'"': "&quot;",
			"'": "&#39;",
			"/": "&#x2F;",
			"`": "&#x60;",
			"=": "&#x3D;",
		};
		return text.replace(/[&<>"'`=\/]/g, function (char) {
			return map[char];
		});
	}

	// Chain from metafield as options

	if (!customElements.get("chain-as-option")) {
		class ChainAsOption extends HTMLElement {
			constructor() {
				super();
				this.variantsSelects = document.querySelector("variant-radios");
				this.chainTypes = this.querySelector("chain-types");
				this.chainLength = this.querySelector("chain-length");
				this.firstRender = true;
			}
			setActiveGenderByClick(event) {
				const button = event.target.closest(".chain-options__toggler-btn");
				if (!button) return;
				const genderValue = button.getAttribute("data-gender-toggler");
				if (genderValue) {
					this.chainTypes?.setActiveMetalType.call(this.chainTypes, { gender: genderValue });
					this.setActiveGender(genderValue);
					this.resetActiveChoose();
					this.chainLength.dispayLengthBlock.call(this.chainLength, false);
				}
			}

			setActiveGender(gender) {
				const allButtons = this.querySelectorAll(".chain-options__toggler-btn");
				Array.from(allButtons).forEach((button) => {
					const isActiveButton = button.getAttribute("data-gender-toggler") === gender;
					button.classList.toggle("active", isActiveButton);
				});
				this.setAttribute("data-active-chain-gender", gender);
			}

			resetActiveChoose() {
				Array.from(this.chainTypes.querySelectorAll("[data-chain-option-type]")).forEach((el) =>
					el.classList.remove("active"),
				);
			}
		}

		customElements.define("chain-as-option", ChainAsOption);

		if (!customElements.get("chain-length")) {
			class ChainLength extends HTMLElement {
				constructor() {
					super();
					this.setVariables();
					this.setEvents();
				}
				setVariables() {
					this.wrapper = this.closest("chain-as-option")
					this.chainTypes = this.wrapper.querySelector("chain-types");
					this.chainLengths = this.querySelectorAll("[data-chain-length-option]");
					this.filteredTypes = JSON.parse(
						document.querySelector("#filteredChainAsOption")?.textContent,
					);
					this.variantsSelects = document.querySelector("variant-radios");
					this.variants = this.variantsSelects.getVariantData();
					this.oldSectionOptionsList = document.querySelector(".custom-options--charm .custom-options-list.chain-length");
					this.metalOptions = document.querySelector(".custom-select--metal .custom-options-list");
					this.lengthTitleEl = this.querySelector("[data-chain-length-title]");
					this.mainTitleEl = this.wrapper.querySelector(".chain-options__chain-title")
					this.optionSubtitle = this.wrapper.querySelector("[data-chain-options-subtitle]");

					this.firstRender = true

					this.productJsonData = JSON.parse(document.querySelector("#productsJsonGlobal").innerHTML)

					// Check if product has no solid tag
					this.hasNoSolidTag = window.noSolidProductTag && this.productJsonData.tags.includes(window.noSolidProductTag);

				}
				setEvents() {
					this.chainLengths.forEach((el) =>
						el.addEventListener("click", this.onLengthClick.bind(this)),
					);
				}
				onLengthClick(event) {
					const currentElement = event.currentTarget;
					const optionValue = currentElement.getAttribute("data-chain-length-option");
					this.lengthTitleEl.style.color = "#121212";
					this.mainTitleEl.style.color = "#121212";
					const isValid = this.setOptionActive(optionValue);

					if (isValid) {
						Array.from(this.chainLengths).map((el) => {
							const isCurrent = el === currentElement;
							el.classList.toggle("active", isCurrent);
						});

						const metal = this.getActiveMetalValue();
						const formatedMetal = metal.toLowerCase().includes("gold") && !this.hasNoSolidTag ? "Solid " + metal : metal;
						this.optionSubtitle.textContent = formatedMetal + " " + optionValue + " Chain"
					}else{
						this.optionSubtitle.textContent = "";
					}

					this.variantsSelects.updateURL.call(this.variantsSelects);
				}

				getActiveMetalValue(){
					return this.metalOptions.querySelector(".custom-option.active input").value;
				}

				renderLengths(type, metal) {
					const currentLengths = this.displayLengthByMetalAndGender(type, metal);
					this.dispayLengthBlock(true);
					this.displayLengthPrice(type, metal);

					const activeChainLengthInput = this.oldSectionOptionsList.querySelector(
						".custom-option.active input",
					);
					const activeChainLength = activeChainLengthInput.value;
					const activeLength = currentLengths.find(
						(el) => el.getAttribute("data-chain-length-option") == activeChainLength,
					);
					const params = new URL(document.location).searchParams;
					let length = params.get("length");
					if(!length){
						this.firstRender = false;
					}
					const firstAvailableLength = currentLengths[0]
					if(this.firstRender && length && activeLength){
						this.firstRender = false;
						activeLength.click();
					}else if(currentLengths.length == 1){
						if(activeLength){
							activeLength.click();
						}else{
							firstAvailableLength.click()
						}
					}else{
						const firstAvailableLengthValue = firstAvailableLength.getAttribute("data-chain-length-option");
						this.setOptionActive(firstAvailableLengthValue)
					}
				}

				setOptionActive(optionValue) {
					const optionsInputs = this.oldSectionOptionsList.querySelectorAll(
						".custom-option:not([style*='display: none']) input",
					);
					const optionsInput = Array.from(optionsInputs).find(
						(input) => input.value === optionValue,
					);
					optionsInput?.click();

					return optionsInput;
				}

				displayLengthByMetalAndGender(type, metal) {
					const lengths = this.getLengthByMetalAndGender(type, metal);
					Array.from(this.chainLengths).map((lengthEl) => {
						const isShowLength = lengths.includes(lengthEl);
						lengthEl.classList.toggle("hidden-chain-option", !isShowLength);
						lengthEl.classList.remove("active")
					});
					return lengths;
				}

				getLengthByMetalAndGender(type, metal) {
					const filteredLength = this.filteredTypes.find((t) => t.title === type).options;
					const filteredOptionsName = filteredLength.map((length) => length.option_name);
					const fullVariants = this.variants.filter((el) => {
						return el.options.includes(metal);
					});
					return Array.from(this.chainLengths).filter((lengthEl) => {
						const dataType = lengthEl.getAttribute("data-chain-length-type");
						const dataOption = lengthEl.getAttribute("data-chain-length-option");
						const isValidMetal = fullVariants.find((variant) =>
							variant.options.includes(dataOption),
						);
						const isValidType = dataType === type;
						const isValidOption = filteredOptionsName.includes(dataOption);
						const isShowLength = isValidType && isValidOption && isValidMetal;
						return isShowLength;
					});
				}

				dispayLengthBlock(isDisplay) {
					this.classList.toggle("hidden", !isDisplay);
				}

				displayLengthPrice(type, metal) {
					const filteredLength = this.getLengthByMetalAndGender(type, metal);
					const typeEl = Array.from(
						this.chainTypes.querySelectorAll("[data-chain-option-type]"),
					).find((el) => el.getAttribute("data-option-type") == type);
					const typePriceEl = typeEl.querySelector("[data-metal-type-price]");
					const typePrice = typePriceEl.getAttribute("data-metal-type-price");
					const metalPrice = typePriceEl.getAttribute("data-type-price");
					const fullVariants = this.variants.filter((el) => {
						return el.options.includes(metal);
					});

					filteredLength.map((lengthEl) => {
						const priceEl = lengthEl.querySelector("[data-chain-length-price]");
						const option = lengthEl.getAttribute("data-chain-length-option");
						const validVariant = fullVariants.find((variant) => variant.options.includes(option));
						const variantPrice = validVariant.price;
						const priceDecrement = Number(variantPrice) - Number(typePrice) - Number(metalPrice);

						priceEl.textContent = priceDecrement
							? `+${getCurrencySign()}${formatPrice(priceDecrement)}`
							: "";
					});
				}
			}
			customElements.define("chain-length", ChainLength);
		}
		if (!customElements.get("chain-types")) {
			class ChainTypes extends HTMLElement {
				constructor() {
					super();
					this.setVariables();
					this.setEventListeres();
					this.onFirstRender();
				}
				setVariables() {
					this.filteredTypes = JSON.parse(
						document.querySelector("#filteredChainAsOption")?.textContent,
					);
					this.wrapper = this.closest("chain-as-option")
					this.typeElements = this.querySelectorAll("[data-chain-option-type]");
					this.variantsSelects = document.querySelector("variant-radios");
					this.chainAsOptionEl = document.querySelector("chain-as-option");
					this.chainLengths = document.querySelector("chain-length");
					this.metalOptions = document.querySelector(".custom-select--metal .custom-options-list");
					this.oldSectionOptionsList = document.querySelector(
						".custom-options--charm .custom-options-list.chain-length",
					);
					this.variants = this.variantsSelects.getVariantData();
					this.titleEl = this.querySelector("[data-chain-type-title]");
					this.titleDefaultText = this.titleEl.textContent;
					this.titleNoChainText = "No Chain"
					this.chainTypeList = this.querySelector(".chain-options__chain-types-list")
					this.optionSubtitle = this.wrapper.querySelector("[data-chain-options-subtitle]");

					this.chainTitleEl = this.wrapper.querySelector(".chain-options__chain-title");
					this.lengthTitleEl = this.chainLengths.querySelector("[data-chain-length-title]")
					
				}
				setEventListeres() {
					this.typeElements.forEach((el) =>
						el.addEventListener("click", this.setChainType.bind(this)),
					);
					this.metalOptions.addEventListener("click", this.onMetalOptionClick.bind(this));
				}

				setChainType(event) {
					const targetType = event.currentTarget;
					this.typeElements.forEach((el) => {
						const isTargetType = el === targetType;
						el.classList.toggle("active", isTargetType);
					});
					this.removeRedFromTitle()
					this.setTypeLengths(targetType);
					this.variantsSelects.updateURL.call(this.variantsSelects);
				}

				removeRedFromTitle(){
					this.titleEl.style.color = "#121212"
					this.chainTitleEl.style.color = "#121212"
					this.lengthTitleEl.style.color = "#121212"
				}

				setTypeLengths(targetType) {
					const typeValue = targetType.getAttribute("data-option-type");
					const activeMetal = this.metalOptions.querySelector(".custom-option.active input").value;
					this.chainLengths.renderLengths.call(this.chainLengths, typeValue, activeMetal);
				}

				/**
				 * @param {{ activeMetalInput: any; gender?: any; }} prop
				 */
				setActiveMetalType(prop) {
					const filterTypesByMetal = this.filterTypesByMetalAndGender(prop);
					if(filterTypesByMetal.length == 0){
						return false
					}
					const filterTypesTitleByMetal = filterTypesByMetal?.map((type) => type.title);
					this.typeElements.forEach((type) => {
						const typeName = type.getAttribute("data-option-type");
						const isTypeActiveByMetal = filterTypesTitleByMetal.includes(typeName);
						type.classList.toggle("active-metal", isTypeActiveByMetal);
					});
					return filterTypesByMetal;
				}

				/**
				 * @param {{ activeMetalInput: any; gender?: any; }} prop
				 */
				filterTypesByMetalAndGender(prop) {
					const activeMetalInput =
						prop.activeMetalInput || this.metalOptions.querySelector(".custom-option.active input");
					const activeMetal = activeMetalInput.value;
					const fullVariants = this.variants.filter((el) => {
						return el.options.includes(activeMetal);
					});
					const filterTypesByMetal = this.filteredTypes.filter((type) => {
						const allType = type.options;
						return allType.find((option) =>
							fullVariants.find((variant) => variant.options.includes(option.option_name)),
						);
					});

					return filterTypesByMetal;
				}

				onMetalOptionClick(event) {
					const activeMetalEl = event.target.closest(".custom-option");
					if (!activeMetalEl) return;
					const activeMetalInput = activeMetalEl.querySelector("input");
					const isHaveTypes = this.setActiveMetalType({ activeMetalInput });
					let isLengthBlockDisplay = false
					if(isHaveTypes){
						this.optionSubtitle.textContent = "";
						this.titleEl.textContent = this.titleDefaultText;
						this.chainTypeList.classList.remove("hidden")
						this.setOptionPrice(activeMetalInput);
						this.setOptionImage(activeMetalInput);
						this.chainTypeList.classList.remove("hidden");
						const activeChainOption =
							this.oldSectionOptionsList.querySelector(".custom-option.active");
						
						if (activeChainOption) {
							const activeType = this.findActiveType(activeChainOption, activeMetalInput);

							if (activeType && isHaveTypes.length == 1) {
								const activeTypeEl = Array.from(this.typeElements).find(
									(el) => el.getAttribute("data-option-type") == activeType.title,
								);
								isLengthBlockDisplay = true
								
								activeTypeEl?.click();
							}
							else{
								this.resetActiveLengthChoose();
								const lengthValue = this.oldSectionOptionsList.querySelector(".custom-option input").value;
								this.chainLengths.setOptionActive.call(this.chainLengths, lengthValue);
							}
						}
						this.chainLengths.dispayLengthBlock.call(this.chainLengths, isLengthBlockDisplay);
					}else{
						this.titleEl.textContent = this.titleNoChainText;
						this.chainTypeList.classList.add("hidden")
					}

					if(!isLengthBlockDisplay){
						this.resetActiveChoose();
					}					
				}

				onFirstRender() {
					const activeMetalEl = this.variantsSelects.querySelector(
						".custom-select--metal .custom-option.active",
					);
					if (!activeMetalEl) return;
					const activeMetalInput = activeMetalEl.querySelector("input");
					const isHasTypes = this.setActiveMetalType({ activeMetalInput });
					if(isHasTypes){
						this.titleEl.textContent = this.titleDefaultText;

						this.setOptionPrice(activeMetalInput);
						this.setOptionImage(activeMetalInput);
						this.chainTypeList.classList.remove("hidden")
						const activeChainOption =
							this.oldSectionOptionsList.querySelector(".custom-option.active");
						if (activeChainOption) {
							const activeType = this.findActiveType(activeChainOption, activeMetalInput);
							const params = new URL(document.location).searchParams;
							let type = params.get("chain-type");
							if (activeType &&  ( isHasTypes.length == 1 || type)) {
								const activeTypeEl = Array.from(this.typeElements).find(
									(el) => el.getAttribute("data-option-type") == activeType.title,
								);
								activeTypeEl?.click();
							}
						}
					}else{
						this.titleEl.textContent = this.titleNoChainText;
						this.chainTypeList.classList.add("hidden")
					}
				}

				findActiveType(activeChainOption, activeMetalInput) {
					const filterTypesByMetal = this.filterTypesByMetalAndGender({ activeMetalInput });

					const activeChainValue = activeChainOption.querySelector("input").value;
					const activeType = filterTypesByMetal.find((type) => {
						return type.options.find((option) => option.option_name == activeChainValue);
					});
					return activeType;
				}

				resetActiveChoose() {
					this.typeElements.forEach((el) => el.classList.remove("active"));
				}
				resetActiveLengthChoose() {
					this.chainLengths.querySelectorAll("[data-chain-length-option]").forEach((el) => el.classList.remove("active"));
				}

				setOptionPrice(activeMetalInput) {
					const filterTypesByMetal = this.filterTypesByMetalAndGender({ activeMetalInput });
					filterTypesByMetal.map((type) => {
						const typeName = type.title;
						const types = type.options;
						const typesOptionsName = types.map((t) => t.option_name);

						const matchingPrices = this.findAllVarintsByOptions(
							typesOptionsName,
							this.variants,
							activeMetalInput.value,
						);
						const minPrice = this.minTypePrice(matchingPrices);

						this.setOptionPriceLabel(typeName, minPrice, activeMetalInput);
					});
				}

				setOptionPriceLabel(type, price, activeMetalInput) {
					const typeEl = Array.from(this.typeElements).find(
						(el) => el.getAttribute("data-option-type") === type,
					);

					const priceEl = typeEl.querySelector("[data-metal-type-price]");
					const plusCharm = "+";
					if (priceEl) {
						const minMetalPrice = this.minMetalPrice(activeMetalInput.value);
						const priceDecrement = Number(price) - Number(minMetalPrice);
						priceEl.setAttribute("data-metal-type-price", minMetalPrice);
						priceEl.setAttribute("data-type-price", priceDecrement);
						priceEl.textContent = priceDecrement
							? `${plusCharm}${getCurrencySign()}${formatPrice(priceDecrement)}`
							: "";
					}
				}

				findAllVarintsByOptions(options, variants, metal) {
					const matchingPrices = [];
					options.map((opt) => {

						const optVatiants = variants.filter(
							(variant) =>  variant.title.includes(opt) && variant.title.includes(metal)
						);
						if(optVatiants.length){
							const minVariantPrice = optVatiants.sort((a, b) => a.price > b.price)[0];
						
							matchingPrices.push({ name: opt, variant: minVariantPrice });
						}
						
					});
					return matchingPrices;
				}

				minTypePrice(matchingPrices) {
					const allVariants = matchingPrices.map((item) => item.variant).flat(1);
					const allPriceVariants = allVariants.map((item) => item.price);
					return matchingPrices.length ? Math.min(...allPriceVariants) : null;
				}

				minMetalPrice(metal) {
					const metalVariants = this.variants.filter((variant) => variant.title.includes(metal));
					const minPrice = Math.min(...metalVariants.map((variant) => variant.price));
					return minPrice;
				}

				setOptionImage(metalEl) {
					const metalHandle = metalEl.getAttribute("data-metal-handle");
					Array.from(this.typeElements).map((el) => {
						const img = el.querySelector(".custom-option__image");
						const allAttributes = img.getAttributeNames();
						const metalActiveAttribute = allAttributes.find((attribute) =>
							attribute.includes(`data-src-${metalHandle}`),
						);
						const src = img.getAttribute(`${metalActiveAttribute}`);
						if (src) {
							img.src = src;
						}
					});
				}
			}

			customElements.define("chain-types", ChainTypes);
		}
	}
})();
